const AppConfig = () => {
  const env = process.env.NODE_ENV;
  const mode = process.env.REACT_APP_MODE;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const graphqlUrl = process.env.REACT_APP_GRAPHQL_URL;
  const clientUrl = process.env.REACT_APP_CLIENT_BASE_URL;

  return {
    env,
    mode,
    baseUrl,
    graphqlUrl,
    clientUrl
  };
};

export default AppConfig();
